import React from 'react'
import SkeletonAlertsButtons from './SkeletonAlertsButtons'

const SkeletonAlertsHeader = () => {
    return (
        <>
            <div className="w-full rounded-[10px] relative min-h-[110px] flex flex-row items-center justify-between px-10 bg-[#7780c4]/50 animate-pulse">
                <div className="flex flex-col justify-center">
                    <div className="h-[31px] w-[150px] bg-lightBG rounded  opacity-50"></div>
                </div>
                <div className="h-[90px] w-[90px] bg-[#7780c4] rounded-full opacity-50 mr-[60px]"></div>
            </div>
            <div className="w-full h-[152px] px-[30px] pt-[26px]">
                <div className="flex flex-row items-center justify-between mt-[15px]">
                    <SkeletonAlertsButtons />
                    <div className="w-[237px] h-10 bg-lightBG rounded-full"></div>
                </div>
            </div>
        </>
    )
}

export default SkeletonAlertsHeader
